module.exports = __webpack_public_path__ + "03_mole.c3afa236.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/03_mole.png
// module id = Hk6V
// module chunks = 0